import { useEffect, useState } from "react";
import styles from "./DropdownMenuInputOther.module.css";

// dropdown menu that has option to select other and write it down
const DropdownMenuInputOther = ({
  name,
  name2,
  data,
  setSpecificState,
  isError,
  defaultValue,
}) => {
  const [selectionValue, setSelectionValue] = useState("");
  const [otherSelectionValue, setOtherSelectionValue] = useState("");
  const [options, setOptions] = useState([]);
  const [otherVisibility, setOtherVisibility] = useState(false);

  const handleSelectionChange = (event) => {
    // using selectedValue beacuse selectionValu
    // is not updated immediately because it is asynchronous
    const selectedValue = event.target.value;
    setSelectionValue(selectedValue);

    if (selectedValue === "Ostalo (navesti)") {
      setOtherVisibility(true);
    } else {
      setOtherVisibility(false);
    }

    setSpecificState(event.target.value);
    sessionStorage.setItem(name, event.target.value);
  };

  useEffect(() => {
    setOptions([...data, "Ostalo (navesti)"]);

    const selectionValueSessionStorage = sessionStorage.getItem(name);
    const otherSelectionValueSessionStorage = sessionStorage.getItem(name2);

    // First check for prop defaultValue, then sessionStorage, otherwise keep empty
    if (defaultValue) {
      setSelectionValue(defaultValue);
      setSpecificState(defaultValue);

      if (
        defaultValue === "Ostalo (navesti)" &&
        otherSelectionValueSessionStorage
      ) {
        setOtherVisibility(true);
        setOtherSelectionValue(otherSelectionValueSessionStorage);
        setSpecificState(otherSelectionValueSessionStorage);
      }
    } else if (selectionValueSessionStorage) {
      setSelectionValue(selectionValueSessionStorage);
      setSpecificState(selectionValueSessionStorage);

      if (selectionValueSessionStorage === "Ostalo (navesti)") {
        setOtherVisibility(true);
        if (otherSelectionValueSessionStorage) {
          setOtherSelectionValue(otherSelectionValueSessionStorage);
          setSpecificState(otherSelectionValueSessionStorage);
        }
      }
    }
  }, [data, name, name2, setSpecificState, defaultValue]);

  const updateOtherChoice = (event) => {
    setSpecificState(event.target.value);
    setOtherSelectionValue(event.target.value);
    sessionStorage.setItem(name2, event.target.value);
  };

  return (
    <div className={styles.dropdownMenuContainerOther}>
      {isError && <p className={styles.errorText}>Ovo polje je obavezno</p>}
      <select
        value={selectionValue}
        onChange={handleSelectionChange}
        className={isError ? styles.error : ""}
      >
        <option value="">Odaberite opciju</option>
        {options.map((member, index) => (
          <option key={index} value={member}>
            {member}
          </option>
        ))}
      </select>

      {otherVisibility && (
        <div>
          <p>Navedite ostale izvore financiranja</p>
          <input
            value={otherSelectionValue}
            type="text"
            placeholder="navedite ostale izvore financiranja..."
            onChange={updateOtherChoice}
          />
        </div>
      )}
    </div>
  );
};

export default DropdownMenuInputOther;
